import { IUserState, userActions } from "../../../state/user";
import { useDispatch, useSelector } from "react-redux";

import { CreateProfileFormType } from "../../../services/user-create-v2/user-create.schema";
import { IRootState } from "../../../state";
import { PAGES_PATH } from "../../../navigation/params";
import { useNavigate } from "react-router-dom";

export const useUserCreateStore = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { createProfile } = useSelector((state: IRootState) => state.user as IUserState);

  const validateCreateProfileStore = () => {
    if (!createProfile) {
      navigate(`${PAGES_PATH.LANDING}`, { replace: true });
    }
  };

  const setCreateProfile = (profile: CreateProfileFormType | null) => {
    dispatch(userActions.setCreateProfile(profile));
  };
  const setLocation = (location: string) => {
    dispatch(userActions.setUserLocation(location));
  };

  const setInviteReferralLink = (link: string, code: string) => {
    dispatch(userActions.setInviteReferralLink(link, code));
  };

  return {
    validateCreateProfileStore,
    setCreateProfile,
    createProfile,
    setLocation,
    setInviteReferralLink,
  };
};

